import { get } from 'lodash'
import { required } from 'utils/validation'

export default function(values) {
  return {
    leaderId: required(get(values, 'leaderId'))
  }
}
